import { BREAKPOINTS, SETTINGS } from '../utils/constants';
import { throttle } from 'throttle-debounce';

const initAccordion = () => {
  const mobileOnlyAccordions = document.querySelectorAll('[data-mobile-accordion]');
  if (!mobileOnlyAccordions) return;

  const toggleAccordions = () => {
    mobileOnlyAccordions.forEach(accordion => {
      window.innerWidth >= BREAKPOINTS.DESKTOP ? accordion.open = true : accordion.open = false;
    });
  };

  toggleAccordions();
  window.addEventListener('resize', throttle(SETTINGS.THROTTLE_DELAY, toggleAccordions));
};

export default initAccordion;
